import * as yup from 'yup';

export const annotationLabelAssignmentSchema = yup.object({
	remarks: yup.string().optional(),
	annotation_label_ids: yup
		.array()
		.of(yup.number().defined())
		.required()
		.min(1, 'At least one diagnosis is required'),
});
